/** @jsxImportSource @emotion/react */

import { IBasePart } from '../part';
import Title from '../../../components/title';

export interface IAccessibilityForInputs {
  labelForInputIds?: Array<string>;
}

export interface ITitlePart extends IBasePart {
  type: 'title';
  accessibilityForInputs?: IAccessibilityForInputs;

  title: string;
  id: string;
  subtitle: string;
  topMargin: number;
}

const TitlePart = (data: ITitlePart) => {
  return (
    <Title
      id={data.accessibilityInfo?.id || data.id}
      title={data.title}
      subtitle={data.subtitle}
      large
      css={{
        margin: `${data.topMargin ?? 0}px 20px 20px`,
      }}
    />
  );
};

export default TitlePart;
